import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { Dispatch, SetStateAction } from "react";

type NumberSelectorProps = {
  disabled?: boolean;
  max?: number;
  number: number;
  setNumber: Dispatch<SetStateAction<number>>;
};

export const NumberSelector = ({
  disabled,
  max = 100,
  number,
  setNumber,
}: NumberSelectorProps) => {
  return (
    <LBox
      alignItems="center"
      flexDirection="row"
      justifyContent="center"
      gap="s3"
    >
      {number > 0 && (
        <LPressable
          disabled={disabled}
          sentryEventName="AccessDetail.Tickets.NumberSelector.Minus"
          onPress={() => {
            setNumber?.((number) => Math.max(1, number - 1));
          }}
        >
          <LBox
            padding="s2"
            backgroundColor="whiteTranslucent10"
            borderRadius="max"
            width={32}
            height={32}
            justifyContent="center"
            alignItems="center"
            opacity={disabled ? 0.5 : 1}
          >
            <LIcon name="minus_simple" size={16} />
          </LBox>
        </LPressable>
      )}

      {number > 0 && (
        <LText
          color={disabled ? "whiteTranslucent" : "white"}
          variant="Body/B2/SemiBold"
        >
          {number}
        </LText>
      )}

      <LPressable
        disabled={disabled}
        sentryEventName="AccessDetail.Tickets.NumberSelector.Plus"
        onPress={() => {
          setNumber?.((number) => Math.min(max ?? 10, number + 1));
        }}
      >
        <LBox
          padding="s2"
          backgroundColor={
            number > 0 ? "whiteTranslucent10" : "blackTranslucent10"
          }
          borderRadius="max"
          width={32}
          height={32}
          justifyContent="center"
          alignItems="center"
          opacity={disabled ? 0.5 : 1}
        >
          <LIcon name="plus_simple" size={16} />
        </LBox>
      </LPressable>
    </LBox>
  );
};
